import { AdditionalOrderColumn, OrdersTab } from 'enums';
import { useOrderQueryFilters } from 'hooks';

import { TraderOrderList } from '../OrderList';

export const TraderHoldCompletedOrders: React.FC = () => {
  useOrderQueryFilters();

  return (
    <TraderOrderList
      tab={OrdersTab.HoldCompleted}
      additionalColumns={[AdditionalOrderColumn.HoldCompleted]}
    />
  );
};
